// Add your JS customizations here

import {header} from "./modules/header";

document.addEventListener('DOMContentLoaded', async (event) => {
	header();
})
